/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable camelcase */
// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _debounce from 'lodash/debounce';
import Tooltip from 'components/Tooltip/Tooltip';

const DEFAULT_LINEHEIGHT = 14;

/** Modified version of "react-clamp-lines" package */
export default class Truncate extends React.Component {
  static propTypes = {
    text: PropTypes.string.isRequired,
    className: PropTypes.string,
    delay: PropTypes.number,
    width: PropTypes.number,
    lines: PropTypes.number,
    ellipsis: PropTypes.string,
    onClampEnd: PropTypes.func,
    style: PropTypes.shape({}),
    tooltip: PropTypes.shape({}),
  };

  constructor(props) {
    super(props);
    this.original = props.text;
    this.lineHeight = 0;
    this.start = 0;
    this.middle = 0;
    this.end = 0;
    this.state = {
      text: '.',
    };
    this.debounced = _debounce(this.clampLines, props.delay);
  }

  componentDidMount() {
    if (this.props.text) {
      this.lineHeight = this.element && (this.element.clientHeight > 0 ? this.element.clientHeight : DEFAULT_LINEHEIGHT) + 1;
      this.element && this.clampLines();
      window.addEventListener('resize', this.debounced);
    }
  }

  componentDidUpdate(prevProps) {
    if (Object.prototype.hasOwnProperty.call(this.props, 'text')) {
      if (this.props.text !== prevProps.text) {
        this.lineHeight = this.element && (this.element.clientHeight > 0 ? this.element.clientHeight : DEFAULT_LINEHEIGHT) + 1;
        this.original = this.props.text;
        this.debounced();
      }
    }
    if (Object.prototype.hasOwnProperty.call(this.props, 'width')) {
      if (this.props.width !== prevProps.width) {
        this.debounced();
      }
    }
    if (Object.prototype.hasOwnProperty.call(this.props, 'lines')) {
      if (this.props.lines !== prevProps.lines) {
        this.debounced();
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.debounced);
  }

  getEllipsis = () => this.props.ellipsis;

  clampLines = () => {
    if (this.element) {
      const maxHeight = (this.lineHeight * this.props.lines) + 1;
      this.start = 0;
      this.middle = 0;
      this.end = this.original.length;

      while (this.start <= this.end) {
        this.middle = Math.floor((this.start + this.end) / 2);
        this.element.innerText = this.original.slice(0, this.middle);
        if (this.middle === this.original.length) {
          this.setState({
            text: this.original
          });
          this.props.onClampEnd && this.props.onClampEnd({ clamped: false, text: this.original });
          return;
        }
        this.clamped = false;
        this.moveMarkers(maxHeight);
      }

      this.element.innerText = this.original.slice(0, this.middle - 5) + this.getEllipsis();
      this.setState({ text: this.element.innerText }, () => {
        this.clamped = true;
        this.props.onClampEnd && this.props.onClampEnd({ clamped: true, text: this.element.innerText, fullText: this.original });
      });
    }
  };

  moveMarkers = (maxHeight) => {
    if (this.element.clientHeight <= maxHeight) {
      this.start = this.middle + 1;
    } else {
      this.end = this.middle - 1;
    }
  };

  render() {
    if (!this.props.text) {
      return null;
    }

    const classes = classnames({
      'clamp-lines': true,
      [this.props.className]: this.props.className
    });

    return (
      <Tooltip
        disable={(Object.keys(this.props.tooltip).length === 0 && true) || !this.clamped}
        {...this.props.tooltip}
      >
        <div className={classes} style={{ wordWrap: 'anywhere', ...this.props.style }}>
          <div
            ref={(e) => {
              this.element = e;
            }}
          >
            {this.state.text}
          </div>
        </div>
      </Tooltip>
    );
  }
}

Truncate.defaultProps = {
  lines: 3,
  delay: 300,
  tooltip: {},
  ellipsis: '...',
  className: undefined,
  onClampEnd: undefined,
  width: null,
  style: {},
};
